import { render } from "./Project1View.vue?vue&type=template&id=81c6cbea&scoped=true"
import script from "./Project1View.vue?vue&type=script&lang=js"
export * from "./Project1View.vue?vue&type=script&lang=js"

import "./Project1View.vue?vue&type=style&index=0&id=81c6cbea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81c6cbea"]])

export default __exports__